import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';

export const $Price = styled.span`
  font-weight: ${fontWeight('bold')};
  font-size: ${({ theme }) => theme.tw.font.size['3xl']};

  @media ${media.maxWidth.lg} {
    font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  }
`;

export const $PriceLine = styled.div`
  ${fontStyle('xs')};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
`;
